<template>
    <div class="tasks-card">
      <img src="/images/promo/connect-features/tasks-card.svg" alt="Tasks card" />
    </div>
</template>

<script>
export default {};
</script>
